/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateDeviceInfoRequest,
  DeviceInfoResponse,
  HTTPValidationError,
  UpdateDeviceInfoRequest,
} from '../models/index';
import {
    CreateDeviceInfoRequestFromJSON,
    CreateDeviceInfoRequestToJSON,
    DeviceInfoResponseFromJSON,
    DeviceInfoResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    UpdateDeviceInfoRequestFromJSON,
    UpdateDeviceInfoRequestToJSON,
} from '../models/index';

export interface CreateDeviceInfoApiDeviceInfosPostRequest {
    createDeviceInfoRequest: CreateDeviceInfoRequest;
    xApiKey?: string | null;
}

export interface DeleteDeviceInfoApiDeviceInfosDeviceInfoIdDeleteRequest {
    deviceInfoId: number;
    xApiKey?: string | null;
}

export interface GetDeviceInfoApiDeviceInfosDeviceInfoIdGetRequest {
    deviceInfoId: number;
    xApiKey?: string | null;
}

export interface GetDeviceInfosApiDeviceInfosGetRequest {
    xApiKey?: string | null;
}

export interface UpdateDeviceInfoApiDeviceInfosDeviceInfoIdPutRequest {
    deviceInfoId: number;
    updateDeviceInfoRequest: UpdateDeviceInfoRequest;
    xApiKey?: string | null;
}

/**
 * 
 */
export class DeviceInfosApi extends runtime.BaseAPI {

    /**
     * Create Device Info
     */
    async createDeviceInfoApiDeviceInfosPostRaw(requestParameters: CreateDeviceInfoApiDeviceInfosPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeviceInfoResponse>> {
        if (requestParameters['createDeviceInfoRequest'] == null) {
            throw new runtime.RequiredError(
                'createDeviceInfoRequest',
                'Required parameter "createDeviceInfoRequest" was null or undefined when calling createDeviceInfoApiDeviceInfosPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/device-infos`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDeviceInfoRequestToJSON(requestParameters['createDeviceInfoRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeviceInfoResponseFromJSON(jsonValue));
    }

    /**
     * Create Device Info
     */
    async createDeviceInfoApiDeviceInfosPost(requestParameters: CreateDeviceInfoApiDeviceInfosPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeviceInfoResponse> {
        const response = await this.createDeviceInfoApiDeviceInfosPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a device info
     * Delete Device Info
     */
    async deleteDeviceInfoApiDeviceInfosDeviceInfoIdDeleteRaw(requestParameters: DeleteDeviceInfoApiDeviceInfosDeviceInfoIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['deviceInfoId'] == null) {
            throw new runtime.RequiredError(
                'deviceInfoId',
                'Required parameter "deviceInfoId" was null or undefined when calling deleteDeviceInfoApiDeviceInfosDeviceInfoIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/device-infos/{device_info_id}`;
        urlPath = urlPath.replace(`{${"device_info_id"}}`, encodeURIComponent(String(requestParameters['deviceInfoId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete a device info
     * Delete Device Info
     */
    async deleteDeviceInfoApiDeviceInfosDeviceInfoIdDelete(requestParameters: DeleteDeviceInfoApiDeviceInfosDeviceInfoIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteDeviceInfoApiDeviceInfosDeviceInfoIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific device info by ID
     * Get Device Info
     */
    async getDeviceInfoApiDeviceInfosDeviceInfoIdGetRaw(requestParameters: GetDeviceInfoApiDeviceInfosDeviceInfoIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeviceInfoResponse>> {
        if (requestParameters['deviceInfoId'] == null) {
            throw new runtime.RequiredError(
                'deviceInfoId',
                'Required parameter "deviceInfoId" was null or undefined when calling getDeviceInfoApiDeviceInfosDeviceInfoIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/device-infos/{device_info_id}`;
        urlPath = urlPath.replace(`{${"device_info_id"}}`, encodeURIComponent(String(requestParameters['deviceInfoId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeviceInfoResponseFromJSON(jsonValue));
    }

    /**
     * Get a specific device info by ID
     * Get Device Info
     */
    async getDeviceInfoApiDeviceInfosDeviceInfoIdGet(requestParameters: GetDeviceInfoApiDeviceInfosDeviceInfoIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeviceInfoResponse> {
        const response = await this.getDeviceInfoApiDeviceInfosDeviceInfoIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all device infos
     * Get Device Infos
     */
    async getDeviceInfosApiDeviceInfosGetRaw(requestParameters: GetDeviceInfosApiDeviceInfosGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DeviceInfoResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/device-infos`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DeviceInfoResponseFromJSON));
    }

    /**
     * Get all device infos
     * Get Device Infos
     */
    async getDeviceInfosApiDeviceInfosGet(requestParameters: GetDeviceInfosApiDeviceInfosGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DeviceInfoResponse>> {
        const response = await this.getDeviceInfosApiDeviceInfosGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing device info
     * Update Device Info
     */
    async updateDeviceInfoApiDeviceInfosDeviceInfoIdPutRaw(requestParameters: UpdateDeviceInfoApiDeviceInfosDeviceInfoIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeviceInfoResponse>> {
        if (requestParameters['deviceInfoId'] == null) {
            throw new runtime.RequiredError(
                'deviceInfoId',
                'Required parameter "deviceInfoId" was null or undefined when calling updateDeviceInfoApiDeviceInfosDeviceInfoIdPut().'
            );
        }

        if (requestParameters['updateDeviceInfoRequest'] == null) {
            throw new runtime.RequiredError(
                'updateDeviceInfoRequest',
                'Required parameter "updateDeviceInfoRequest" was null or undefined when calling updateDeviceInfoApiDeviceInfosDeviceInfoIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/device-infos/{device_info_id}`;
        urlPath = urlPath.replace(`{${"device_info_id"}}`, encodeURIComponent(String(requestParameters['deviceInfoId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDeviceInfoRequestToJSON(requestParameters['updateDeviceInfoRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeviceInfoResponseFromJSON(jsonValue));
    }

    /**
     * Update an existing device info
     * Update Device Info
     */
    async updateDeviceInfoApiDeviceInfosDeviceInfoIdPut(requestParameters: UpdateDeviceInfoApiDeviceInfosDeviceInfoIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeviceInfoResponse> {
        const response = await this.updateDeviceInfoApiDeviceInfosDeviceInfoIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
